// 电控集中器配置
const electricBasicConfigJurisdiction = [
  { id: '005001001', label: '添加集中器', children: [] },
  { id: '005001002', label: '删除集中器', children: [] },
  { id: '005001003', label: '修改集中器', children: [] }
]

// 电表
const electricMeterJurisdiction = [
  { id: '005002001', label: '添加电表', children: [] },
  { id: '005002002', label: '删除电表', children: [] },
  { id: '005002003', label: '修改电表', children: [] },
  { id: '005002004', label: '查看历史电量', children: [] },
  { id: '005002005', label: '导入电表', children: [] },
  { id: '005002006', label: '导出电表', children: [] },
  { id: '005002007', label: '查看历史电量导出', children: [] }
]

// 电量监测
const electricityMonitoringJurisdiction = [
  { id: '005015001', label: '导出', children: [] }
]

// 收费配置
const electricSfpzJurisdiction = [
  { id: '005003001', label: '修改', children: [] }
]

// 场景配置
const electricCJpzJurisdiction = [
  { id: '005004002', label: '添加场景', children: [] },
  { id: '005004003', label: '修改场景', children: [] },
  { id: '005004001', label: '删除场景', children: [] }
]

// 结算配置
const electricJSpzJurisdiction = [
  { id: '005005001', label: '修改', children: [] }
]

// 按电表统计
const electricQuantityJurisdiction = [
  { id: '005006001', label: '导出', children: [] }
]

// 按住户统计
const electricQuantityPublicJurisdiction = [
  { id: '005007001', label: '导入公摊用电', children: [] },
  { id: '005007002', label: '导出', children: [] }
]

// 导出充值记录
const electricCzJurisdiction = [
  { id: '005009001', label: '导出', children: [] }
]

// 结算记录
const settlementRecordJurisdiction = [
  { id: '005010001', label: '导出', children: [] }
]

// 导出充值记录
const electricYeJurisdiction = [
  { id: '005008001', label: '余额推送配置', children: [] },
  { id: '005008002', label: '导出', children: [] },
  { id: '005008003', label: '结算', children: [] }
]

// 设备状态日志
const controllerDeviceStatusLogJurisdiction = [
  { id: '005011001', label: '导出', children: [] }
]

// 智慧用电
const electricServiceJurisdictionChildren = [
  {
    id: '005013000',
    label: '概览',
    routerName: 'electronic-over-view',
    children: []
  },
  {
    id: '005001000',
    label: '集中器管理',
    routerName: 'controller-management',
    children: electricBasicConfigJurisdiction
  },
  {
    id: '005002000',
    label: '电表管理',
    routerName: 'ammeter-management',
    children: electricMeterJurisdiction
  },
  {
    id: '005003000',
    label: '收费配置',
    routerName: 'electronic-config-center',
    children: electricSfpzJurisdiction
  },
  {
    id: '005004000',
    label: '场景配置',
    routerName: 'device-scene-config',
    children: electricCJpzJurisdiction
  },
  {
    id: '005005000',
    label: '结算配置',
    routerName: 'electronic-config-settle',
    children: electricJSpzJurisdiction
  },
  {
    id: '005006000',
    label: '按电表统计',
    routerName: 'electric-quantity',
    children: electricQuantityJurisdiction
  },
  {
    id: '005007000',
    label: '按住户统计',
    routerName: 'electric-quantity-public',
    children: electricQuantityPublicJurisdiction
  },
  {
    id: '005015000',
    label: '电表读数',
    routerName: 'electricity-monitoring',
    children: electricityMonitoringJurisdiction
  },
  {
    id: '005008000',
    label: '余额管理',
    routerName: 'electronic-rent-money',
    children: electricYeJurisdiction
  },
  {
    id: '005009000',
    label: '充值记录',
    routerName: 'electronic-pay-record',
    children: electricCzJurisdiction
  },
  {
    id: '005010000',
    label: '结算记录',
    routerName: 'settlement-record',
    children: settlementRecordJurisdiction
  },
  {
    id: '005011000',
    label: '设备状态日志',
    routerName: 'controller-device-status-log',
    children: controllerDeviceStatusLogJurisdiction
  },
  {
    id: '005012000',
    label: '操作日志',
    routerName: 'electronic-control-log',
    children: []
  }
]

const electricServiceJurisdiction = {
  id: '005',
  label: '智慧用电',
  children: electricServiceJurisdictionChildren
}

export { electricServiceJurisdiction }



// WEBPACK FOOTER //
// ./src/utils/jurisdiction/electricServiceJurisdiction.js